import "./HomePage.css";
import CodeAnimation from "../../assets/animations/code.json";
import Lottie from "lottie-react";
import { useEffect, useRef, useState } from "react";
import { animated, useSpring } from "@react-spring/web";
import { windowFullWidth } from "../../utils/UIHelper";
import ReactLogo from "../../assets/icons/react-logo.png";
import { Fade, Zoom } from "@mui/material";
import WorkCard from "../../components/WorkCard/WorkCard";
import PhoneModal from "../../components/PhoneModal/PhoneModal";
import { appList, contactInfo } from "../../assets/DATA";
import { PageBehaviour } from "../../assets/allTypes";
import RowInfo from "../../components/RowInfo/RowInfo";

const HomePage = ({ pageBehaviour }: any) => {
	const experienceListRef: React.LegacyRef<HTMLDivElement> = useRef(null);
	const workListRef: React.LegacyRef<HTMLDivElement> = useRef(null);
	// const [pageBehaviour, setPageBehaviour] = useState<PageBehaviour>("HOME");
	const [phoneModalVisible, setPhoneModalVisible] = useState(false);
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
	const [selectedAppImages, setSelectedAppImages] = useState<
		{
			id: string;
			renderItem: React.JSX.Element;
		}[]
	>([]);
	const [isLoadingAppImages, setIsLoadingAppImages] = useState(false);

	const [home, setHome] = useSpring(() => ({
		from: { x: 0 },
	}));
	const [work, setWork] = useSpring(() => ({
		from: { x: windowFullWidth },
	}));
	const [experience, setExperience] = useSpring(() => ({
		from: { x: windowFullWidth },
	}));
	const [contact, setContact] = useSpring(() => ({
		from: { x: windowFullWidth },
	}));

	useEffect(() => {
		const handleResize = () => {
			const windowWidth = window.innerWidth;
			setIsMobile(windowWidth <= 768);
		};

		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	useEffect(() => {
		if (pageBehaviour === "HOME") {
			setHome({ to: { x: 0 } });
			setWork({ to: { x: windowFullWidth } });
			setExperience({ to: { x: windowFullWidth } });
			setContact({ to: { x: windowFullWidth } });
		} else if (pageBehaviour === "WORK") {
			setHome({ to: { x: -windowFullWidth } });
			setWork({ to: { x: 0 } });
			setExperience({ to: { x: windowFullWidth } });
			setContact({ to: { x: windowFullWidth } });
			workListRef.current?.scrollTo(0, 0);
		} else if (pageBehaviour === "EXPERIENCE") {
			setHome({ to: { x: -windowFullWidth } });
			setWork({ to: { x: -windowFullWidth } });
			setExperience({ to: { x: 0 } });
			setContact({ to: { x: windowFullWidth } });
			experienceListRef.current?.scrollTo(0, 0);
		} else if (pageBehaviour === "CONTACT") {
			setHome({ to: { x: -windowFullWidth } });
			setWork({ to: { x: -windowFullWidth } });
			setExperience({ to: { x: -windowFullWidth } });
			setContact({ to: { x: 0 } });
		}
	}, [pageBehaviour]);

	return (
		<div className="home-box">
			{/* HOME */}
			{pageBehaviour === "HOME" && (
				<Fade
					in={pageBehaviour === "HOME"}
					timeout={{ enter: 1500, exit: 500 }}
				>
					<animated.div
						style={{
							alignSelf: "center",
							marginTop: "10vh",
							zIndex: 99,
							alignItems: "center",
							justifyContent: "center",
							position: "absolute",
							width: "100%",
							...home,
						}}
					>
						<div className="home-container">
							{/* <p
								style={{
									color: "white",
									fontWeight: "bold",
									marginBlock: 0,
									fontSize: "clamp(40px, 10vw, 90px)",
								}}
							>
								YILMAZ YAKUT
							</p> */}
							{/* <img
								alt="img"
								src={ReactLogo}
								className="react-logo"
							/> */}
							{/* <Zoom in timeout={{ enter: 1000 }}>
								<p
									style={{
										color: "white",
										fontWeight: "200",
										marginBlock: 0,
										letterSpacing: 10,
										marginTop: 16,
										fontSize: "clamp(16px, 4vw, 24px)",
									}}
								>
									REACT NATIVE DEVELOPER
								</p>
							</Zoom> */}
							<Zoom in timeout={{ enter: 1000 }}>
								<img
									alt="img"
									src={require("../../assets/icons/avatar.png")}
									style={{
										height: 200,
										marginTop: 16,
										width: 400,
										objectFit:
											"contain",
									}}
								/>
							</Zoom>
							<Zoom in timeout={{ enter: 2000 }}>
								<div className="mission-statement">
									<h2>
										Welcome to Archi
										Tech Gaming!
									</h2>
									<p>
										Welcome to Archi
										Tech Gaming, your
										gateway to a world
										of captivating
										mobile games! Since
										2018, we've been
										dedicated to
										crafting immersive
										gaming experiences
										that transcend
										boundaries and
										ignite the
										imagination.
									</p>
									<p>
										At Archi Tech
										Gaming, we pride
										ourselves on our
										diverse portfolio of
										mobile games, each
										meticulously
										designed to deliver
										thrills and
										excitement to
										players of all ages.
									</p>
									<p>
										From the pulsating
										neon landscapes that
										define our signature
										style to the elegant
										simplicity of our
										more understated
										offerings, our
										commitment to
										innovation knows no
										bounds.
									</p>
									<p>
										With 7 mobile game
										projects already
										under our belt and
										countless more in
										the pipeline, the
										journey is just
										beginning.
									</p>
									<p>
										Join us as we
										continue to push the
										boundaries of mobile
										gaming, exploring
										new worlds, and
										crafting
										unforgettable
										adventures. Welcome
										to the Archi Tech
										Gaming family, where
										the possibilities
										are endless, and the
										fun never stops.
									</p>
								</div>
							</Zoom>
						</div>
					</animated.div>
				</Fade>
			)}
			{/* CONTACT */}
			{pageBehaviour === "CONTACT" && (
				<Fade
					in={pageBehaviour === "CONTACT"}
					timeout={{ enter: 1500, exit: 500 }}
				>
					<animated.div
						style={{
							alignSelf: "center",
							marginTop: "10vh",
							zIndex: 99,
							alignItems: "center",
							justifyContent: "center",
							position: "absolute",
							...contact,
						}}
					>
						<div
							style={{
								display: "flex",
								alignItems: "center",
							}}
						>
							<img
								alt="img"
								src={require("../../assets/icons/avatar.png")}
								style={{
									height: "20vh",
									width: "20vw",
									maxHeight: 300,
									maxWidth: 150,
									borderRadius: 99,
									objectFit: "contain",
									marginRight: 32,
									// marginBottom: 24,
									pointerEvents: "none",
									userSelect: "none",
								}}
							/>
							<div className="contact-card-container">
								<div
									style={{
										display: "flex",
										alignItems:
											"center",
									}}
								>
									<div
										style={{
											display: "flex",
											flexDirection:
												"column",
											alignItems:
												"baseline",
										}}
									>
										<p
											style={{
												marginBlock: 0,
												fontSize: 32,
												fontWeight:
													"bold",
											}}
										>
											Yilmaz Yakut
										</p>
										<p
											style={{
												marginBlock: 0,
												fontSize: 10,
												marginTop: 8,
											}}
										>
											REACT NATIVE
											DEVELOPER
										</p>
									</div>
								</div>
							</div>
						</div>

						{contactInfo.map((item, index) => (
							<RowInfo
								isMobile={isMobile}
								onClick={() => {
									if (
										item.contactId ===
										"email"
									) {
										window.open(
											"mailto:yilmazykt@hotmail.com",
											"_blank"
										);
									} else if (
										item.contactId ===
										"linkedin"
									) {
										window.open(
											"https://www.linkedin.com/in/yilmazyakut/",
											"_blank"
										);
									} else if (
										item.contactId ===
										"github"
									) {
										window.open(
											"https://github.com/yilmazyakut",
											"_blank"
										);
									}
								}}
								icon={item.icon}
								text={item.text}
								index={index}
							/>
						))}
					</animated.div>
				</Fade>
			)}
			{/* <Lottie
				className="home-code-anim"
				animationData={CodeAnimation}
			/> */}
			{/* {isLoadingAppImages && (
				<div className="spinner-container">
					<Zoom
						in={isLoadingAppImages}
						timeout={{ enter: 500, exit: 500 }}
					>
						<div
							className="spinner icon-spinner-2"
							aria-hidden="true"
						/>
					</Zoom>

					<Fade
						in={isLoadingAppImages}
						timeout={{ enter: 500, exit: 500 }}
					>
						<div className="spinner-overlay-bg" />
					</Fade>
				</div>
			)} */}
			{selectedAppImages.length > 0 && (
				<PhoneModal
					isMobile={isMobile}
					isVisible={phoneModalVisible}
					onCloseModal={() => {
						setPhoneModalVisible(false);
						setTimeout(() => {
							setSelectedAppImages([]);
						}, 600);
					}}
					selectedAppImages={selectedAppImages}
				/>
			)}
		</div>
	);
};

export default HomePage;
